import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-m-leoknowledgeuisurfacesample",
  "use": "icon-soc-m-leoknowledgeuisurfacesample-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-m-leoknowledgeuisurfacesample\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\" fill=\"currentColor\">\r\n<circle cx=\"780\" cy=\"180\" r=\"28\" /><rect x=\"224\" y=\"224\" width=\"576\" height=\"576\" rx=\"48\" /><path d=\"M320 352h384v64H320zM320 480h288v64H320zM320 608h192v64H320z\" fill=\"#fff\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-m-leoknowledgeuisurfacesample.svg
// module id = A+cY
// module chunks = 534